import { createFileRoute } from '@tanstack/react-router';

import { AuditFormPage } from '@/features/audit-workflow/components/AuditFormPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/audit/audits/new')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.createAudit'),
  }),
  component: AuditCreateRoute,
});

function AuditCreateRoute() {
  return <AuditFormPage mode="create" />;
}
